module.exports = __webpack_public_path__ + "static/media/manna.3319ea6d.png";